<div class="content-div">
        <div class="auto-refresh-warning" *ngIf="anySelected">
          <i class="fal fa-exclamation-triangle"></i>
          {{ 'realtime:queuedetails_lang_stoprefresh' | i18next }}
        </div>
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <div class="info-bar-right">
    <app-basic-button id="help-btn-real-time-overview-queue" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
    </div>

    </div>
  <div class="top-bar">
    <span class="page-header">{{ 'realtime:queueDetails' | i18next }} <span class="header-details">{{ queueDescription || '‒' }}</span></span>
    <span class="spacer"></span>
  </div>
  <div class="top-bar buttons-bar">
    <app-basic-button id="select-all-btn-real-time-overview-queue" *ngIf="!allSelected && propertyAllowDelete" type="secondary" [text]="'Select all' | i18next"  size="small" [disabled]="!anySelectable"
      (click)="toggleSelectAll(true)"></app-basic-button>
    <app-basic-button id="deselect-all-btn-real-time-overview-queue" *ngIf="allSelected && propertyAllowDelete" type="secondary" [text]="'Deselect all' | i18next"  size="small"
      (click)="toggleSelectAll(false)"></app-basic-button>
    <app-basic-button id="edit-reserved-btn-real-time-overview-queue" *ngIf="canEditReserved" type="secondary" [text]="'realtime:editReservedPreferred' | i18next" [disabled]="!canEditReserved"  size="small"
      (click)="onEditReserved()"></app-basic-button>
    <app-basic-button id="delete-selected-btn-real-time-overview-queue" *ngIf="propertyAllowDelete" type="decline" size="small"  [style.visibility]="anySelected ? 'visible' : 'hidden'"
      [disabled]="!anySelected" (click)="onDeleteSelected()"><i class="fal fa-times fs-14"></i>{{ 'reports:Delete' | i18next }}</app-basic-button>
    <app-filter-input id="search-input-real-time-overview-queue" [(model)]="searchKeyword" [placeholder]="'realtime:search_placeholder' | i18next"
      [width]="'300px'"></app-filter-input>
    <app-basic-button id="search-btn-real-time-overview-queue" (click)="onSearch()" [disabled]="!searchKeyword?.trim() || isLoading" isIcon="true" size="medium"><i class="fal fa-search fs-14"></i></app-basic-button>
    <app-basic-button id="clear-search-btn-real-time-overview-queue" *ngIf="isSearching" type="secondary" [text]="'realtime:clear' | i18next" size="medium" (click)="onClearSearch()"></app-basic-button>

    <div class="right">
      <app-basic-toggle id="toggle-system-queue-real-time-overview-queue" [(checked)]="showSystemQueue" [label]="'realtime:system_queue' | i18next"
        (checkedChange)="onToggleSystemQueue($event)" size="small"></app-basic-toggle>

      <app-filter-input id="filter-input-real-time-overview-queue" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
        [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'300px'"></app-filter-input>
    </div>

  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">
      <!-- 0) Select (conditional like old Model.PropertyAllowDelete) -->
      <ng-container *ngIf="propertyAllowDelete" matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="text-center">
        </th>
        <td mat-cell *matCellDef="let r" class="text-center">
          <ng-container *ngIf="r.allowDelete; else dash2">
            <app-basic-checkbox
              id="checkbox-{{r.requestId}}-real-time-overview-queue"
              [model]="selected[r.requestId] || false"
              (change)="toggleOne(r.requestId, $event)"
              [attr.data-media]="r.mediaType" ></app-basic-checkbox>
          </ng-container>
          <ng-template #dash2>‒</ng-template>
        </td>
      </ng-container>



      <!-- 1) Number / Caller -->
      <ng-container matColumnDef="formattedNumberFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:numberFrom' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">{{ r.formattedNumberFrom }}</td>
      </ng-container>

      <!-- 2) Profile description -->
      <ng-container matColumnDef="callerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:profile_description' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" [title]="r.description || '‒'">
          {{ r.callerName || '‒' }}
        </td>
      </ng-container>

      <!-- 3) Type (color pill like old app) -->
      <ng-container matColumnDef="formattedType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:queuedetails_Type' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">
          <span class="type-pill"
                [ngStyle]="{ 'background-color': r.bColorType, 'color': r.fColorType }">
            {{ r.formattedType }}
          </span>
        </td>
      </ng-container>

      <!-- 4) SLA -->
      <ng-container matColumnDef="formattedSla">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:SLA' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.formattedSla === '-1' ? '-' : r.formattedSla }}</td>
      </ng-container>

      <!-- 5) Time in queue -->
      <ng-container matColumnDef="timeInQueue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:timeInQueue' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.formattedTimeInQueue }}</td>
      </ng-container>

      <!-- 6) VIP -->
      <ng-container matColumnDef="formattedVip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:VIP' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">
          <ng-container *ngIf="(r.vip || 0) > 0; else vipDefault">
            <i class="fas fa-star "></i>
          </ng-container>
          <ng-template #vipDefault>{{ r.formattedVip }}</ng-template>
        </td>
      </ng-container>

      <!-- 7) Callback -->
      <ng-container matColumnDef="formattedCallback">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:callback' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">
          <ng-container [ngSwitch]="r.callback || 0">
            <span *ngSwitchCase="0">{{ r.formattedCallback }}</span>
            <span *ngSwitchCase="1" class="bold">&#x21B0;</span>
            <span *ngSwitchDefault class="bold">&#x21B0; ({{ r.callback }})</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- 8) Scheduled time (conditional like old Model.ShowFeatureCallback) -->
      <ng-container *ngIf="showFeatureCallback" matColumnDef="formattedCallbackScheduledTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:scheduledcallback_scheduledtime' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.formattedCallbackScheduledTime }}</td>
      </ng-container>

      <!-- 9) Reserved preferred -->
      <ng-container matColumnDef="formattedReservedFlag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:reservedPreferred' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">{{ r.formattedReservedFlag }}</td>
      </ng-container>

      <!-- 10) System queue (toggle visibility; keep column alignment) -->
      <ng-container matColumnDef="systemQueue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
            [style.display]="showSystemQueue ? 'table-cell' : 'none'">
          {{ 'realtime:system_queue' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r"
            [style.display]="showSystemQueue ? 'table-cell' : 'none'"
            [title]="r.queueDescription || '‒'">
          {{ shortQueueDescription(r) }}
        </td>
      </ng-container>

      <!-- 11) Preview -->
      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          {{ 'realtime:queuedetails_lang_preview' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-center">
          <app-basic-button id="preview-btn-{{r.requestId}}" type="secondary" isIcon="true" size="small" *ngIf="isEmailMedia(r.mediaType); else dash"
            (click)="onPreview(r, $event)">
            <!-- <i class="fal fa-eye"></i> -->
             <img src="assets/Img/eye_ico.svg" alt="Preview" />
          </app-basic-button>
          <ng-template #dash>‒</ng-template>
        </td>
      </ng-container>



      <!-- Header & rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          [attr.data-id]="row.requestId"
          [attr.title]="row.description || null"
          [attr.data-queue]="row.queueDescription || null">
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>

    <div class="rows-status" *ngIf="dataSource.data?.length">
      {{ 'realtime:rowsShown' | i18next : { defaultValue: 'Showing' } }}
      {{ curDisplayRows }}
      {{ 'realtime:rows' | i18next : { defaultValue: 'rows' } }}
    </div>

    <!-- “Get next” link, like the old app footer -->
    <div class="center" *ngIf="hasMore && !isLoading">
      <a id="load-more-link-real-time-overview-queue" href="#" style="color:#4e64ca" (click)="$event.preventDefault(); onLoadMore()">
        {{ 'realtime:getnext' | i18next : { defaultValue: 'Get next' } }}
      </a>
    </div>

  </div>
</div>
